angular.module('fakeModule', []);